// eslint-disable-next-line
import logo from '!file-loader!./logo.svg';
import styles from './Header.module.css';
import DevSettings from '../../DevSettings';
import { Grid } from '@mui/material';

interface HeaderProps {
  rendered: boolean;
}

const Header = (props: HeaderProps) => {
  if (!props.rendered) {
    return null;
  }

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item xs={8}>
        <img className={styles.logo} src={logo} alt="Metria FastighetSök" />
      </Grid>
      <Grid item xs={4} sx={{ pr: 2 }}>
        <DevSettings />
      </Grid>
    </Grid>
  );
};

export default Header;
